import brand from 'brand'
import WithHeaderLayout from 'components/with-header-layout'

export default function TwoColumnLayout({ children, page = 'home' }) {
  const bannerImageUrl = process.env.REACT_APP_BANNER_IMAGE_URL
  const isChicchaching = brand.theme === 'chicchaching'

  if (isChicchaching) {
    return <WithHeaderLayout page={page}>{children}</WithHeaderLayout>
  }

  return (
    <div className="bg-cover bg-fixed" style={{ backgroundImage: `url(${bannerImageUrl})` }}>
      <div className="ml-auto h-screen overflow-auto bg-white lg:max-w-2xl">
        <div className="flex min-h-full md:items-center">{children}</div>
      </div>
    </div>
  )
}
